import { render, staticRenderFns } from "./recruitBanner.vue?vue&type=template&id=608ec454&scoped=true&"
import script from "./recruitBanner.vue?vue&type=script&lang=js&"
export * from "./recruitBanner.vue?vue&type=script&lang=js&"
import style1 from "./recruitBanner.vue?vue&type=style&index=1&id=608ec454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ec454",
  null
  
)

export default component.exports